module.exports = __webpack_public_path__ + "static/media/adelaide.764c9255.png";